// import { grommet } from "grommet";
import { deepFreeze } from "grommet/utils";

// https://grommet-theme-builder.netlify.app/
export const theme = deepFreeze({
  "global": {
    "colors": {
      "active": "#FFCC33",
      "brand": "#0C5449",
      "focus": "active",
      "placeholder": "Silver",
      "selected": "focus",
      "accent-1": "focus",
      "accent-2": "focus",
      "accent-3": "focus",
      "accent-4": "gold",
      "neutral-1": "focus",
      "neutral-2": "brand",
      "status-unknown": "silver",
      "status-disabled": "silver"
    }
  }
});
